import { render, staticRenderFns } from "./RestaurantSelectionView.vue?vue&type=template&id=0288f0fa&scoped=true"
import script from "./RestaurantSelectionView.vue?vue&type=script&lang=js"
export * from "./RestaurantSelectionView.vue?vue&type=script&lang=js"
import style0 from "./RestaurantSelectionView.vue?vue&type=style&index=0&id=0288f0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0288f0fa",
  null
  
)

export default component.exports